import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import './index.css';

const queryClient = new QueryClient({
 defaultOptions: {
  queries: {
   staleTime: 1000 * 60 * 5, // 5 minutes
   retry: 1,
  },
 },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
 <React.StrictMode>
  <QueryClientProvider client={queryClient}>
   <BrowserRouter>
    <App />
   </BrowserRouter>
  </QueryClientProvider>
 </React.StrictMode>
);
